import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Grid2 } from "@mui/material";
import { selectLastCertificatesByCompanyName } from "../../store/certificateSlice/certificateSelectors";
import { getAllCertificates } from "../../store/certificateSlice/certificateRequest";
import CertificateContainer from "../CertificateContainer";
import NavigatorArrows from "../../components/NavigatorArrows";
import { createMemberAreaLink, PAGE_LIST } from "../../pages";
import { selectCurrentUser } from "../../store/userSlice/userSelectors";
import CompanyOverview from "../../components/CompanyOverview";

import classes from './index.module.scss';

const CompanyContainer = () => {
  const dispatch = useDispatch();
  const { companyName } = useParams();
  const currentUser = useSelector(selectCurrentUser);
  const companyList = useSelector(selectLastCertificatesByCompanyName) || [];
  const company = companyList.find((company) => company.name === companyName);
  const memberAreaAvailable = currentUser?.isAdmin || currentUser?.company?.name === company?.name;

  useEffect(() => {
    dispatch(getAllCertificates());
  }, []);

  if (!company) {
    return null;
  }

  const memberAreaLink = createMemberAreaLink(company.name);

  return (
    <Grid2 container className={classes.wrapper}>
      <Grid2 container size={12} className={classes.container}>
        <NavigatorArrows
          leftLink={
            {
              href: PAGE_LIST.PVP,
              title: 'Premium Verification Program',
            }
          }
          rightLink={
            memberAreaAvailable ?
            {
              href: memberAreaLink,
              title: 'Member Area',
            } : null
          }
        />
        <CompanyOverview company={company} />
      </Grid2>
      <CertificateContainer type={CertificateContainer.TYPES.PREMIUM} companyId={company?.id} clearBoxHeight />
    </Grid2>
  );
}

export default CompanyContainer;